/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleBigQueryGa4DailyReportRowData } from './GoogleBigQueryGa4DailyReportRowData';
import {
    GoogleBigQueryGa4DailyReportRowDataFromJSON,
    GoogleBigQueryGa4DailyReportRowDataFromJSONTyped,
    GoogleBigQueryGa4DailyReportRowDataToJSON,
    GoogleBigQueryGa4DailyReportRowDataToJSONTyped,
} from './GoogleBigQueryGa4DailyReportRowData';
import type { GoogleBigQueryGa4ReportRowData } from './GoogleBigQueryGa4ReportRowData';
import {
    GoogleBigQueryGa4ReportRowDataFromJSON,
    GoogleBigQueryGa4ReportRowDataFromJSONTyped,
    GoogleBigQueryGa4ReportRowDataToJSON,
    GoogleBigQueryGa4ReportRowDataToJSONTyped,
} from './GoogleBigQueryGa4ReportRowData';
import type { GoogleBigQueryGa4RevenueCurrencyData } from './GoogleBigQueryGa4RevenueCurrencyData';
import {
    GoogleBigQueryGa4RevenueCurrencyDataFromJSON,
    GoogleBigQueryGa4RevenueCurrencyDataFromJSONTyped,
    GoogleBigQueryGa4RevenueCurrencyDataToJSON,
    GoogleBigQueryGa4RevenueCurrencyDataToJSONTyped,
} from './GoogleBigQueryGa4RevenueCurrencyData';

/**
 * 
 * @export
 * @interface GoogleBigQueryGa4ReportData
 */
export interface GoogleBigQueryGa4ReportData {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleBigQueryGa4ReportData
     */
    available?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4ReportData
     */
    completeness?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4ReportData
     */
    fetchedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4ReportData
     */
    publishedAt?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GoogleBigQueryGa4ReportData
     */
    rangeSince?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GoogleBigQueryGa4ReportData
     */
    rangeUntil?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4ReportData
     */
    events?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4ReportData
     */
    sessions?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4ReportData
     */
    purchases?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4ReportData
     */
    transactions?: number;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4ReportData
     */
    purchaseRevenue?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4ReportData
     */
    purchaseRevenueMissingCount?: number;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4ReportData
     */
    canonicalPurchaseRevenue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4ReportData
     */
    purchaseRevenueCurrency?: string | null;
    /**
     * 
     * @type {GoogleBigQueryGa4ReportDataPurchaseRevenueAvailabilityEnum}
     * @memberof GoogleBigQueryGa4ReportData
     */
    purchaseRevenueAvailability?: GoogleBigQueryGa4ReportDataPurchaseRevenueAvailabilityEnum;
    /**
     * 
     * @type {Array<GoogleBigQueryGa4RevenueCurrencyData>}
     * @memberof GoogleBigQueryGa4ReportData
     */
    purchaseRevenueByCurrency?: Array<GoogleBigQueryGa4RevenueCurrencyData>;
    /**
     * 
     * @type {Array<GoogleBigQueryGa4ReportRowData>}
     * @memberof GoogleBigQueryGa4ReportData
     */
    landingPages?: Array<GoogleBigQueryGa4ReportRowData>;
    /**
     * 
     * @type {Array<GoogleBigQueryGa4ReportRowData>}
     * @memberof GoogleBigQueryGa4ReportData
     */
    sources?: Array<GoogleBigQueryGa4ReportRowData>;
    /**
     * 
     * @type {Array<GoogleBigQueryGa4ReportRowData>}
     * @memberof GoogleBigQueryGa4ReportData
     */
    paths?: Array<GoogleBigQueryGa4ReportRowData>;
    /**
     * 
     * @type {Array<GoogleBigQueryGa4ReportRowData>}
     * @memberof GoogleBigQueryGa4ReportData
     */
    items?: Array<GoogleBigQueryGa4ReportRowData>;
    /**
     * 
     * @type {Array<GoogleBigQueryGa4DailyReportRowData>}
     * @memberof GoogleBigQueryGa4ReportData
     */
    daily?: Array<GoogleBigQueryGa4DailyReportRowData>;
}


/**
 * @export
 */
export const GoogleBigQueryGa4ReportDataPurchaseRevenueAvailabilityEnum = {
    Available: 'AVAILABLE',
    MixedCurrency: 'MIXED_CURRENCY',
    UnknownCurrency: 'UNKNOWN_CURRENCY',
    Unavailable: 'UNAVAILABLE'
} as const;
export type GoogleBigQueryGa4ReportDataPurchaseRevenueAvailabilityEnum = typeof GoogleBigQueryGa4ReportDataPurchaseRevenueAvailabilityEnum[keyof typeof GoogleBigQueryGa4ReportDataPurchaseRevenueAvailabilityEnum];


/**
 * Check if a given object implements the GoogleBigQueryGa4ReportData interface.
 */
export function instanceOfGoogleBigQueryGa4ReportData(value: object): value is GoogleBigQueryGa4ReportData {
    return true;
}

export function GoogleBigQueryGa4ReportDataFromJSON(json: any): GoogleBigQueryGa4ReportData {
    return GoogleBigQueryGa4ReportDataFromJSONTyped(json, false);
}

export function GoogleBigQueryGa4ReportDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleBigQueryGa4ReportData {
    if (json == null) {
        return json;
    }
    return {
        
        'available': json['available'] == null ? undefined : json['available'],
        'completeness': json['completeness'] === undefined ? undefined : json['completeness'] === null ? null : json['completeness'],
        'fetchedAt': json['fetchedAt'] === undefined ? undefined : json['fetchedAt'] === null ? null : json['fetchedAt'],
        'publishedAt': json['publishedAt'] === undefined ? undefined : json['publishedAt'] === null ? null : json['publishedAt'],
        'rangeSince': json['rangeSince'] === undefined ? undefined : json['rangeSince'] === null ? null : (new Date(json['rangeSince'])),
        'rangeUntil': json['rangeUntil'] === undefined ? undefined : json['rangeUntil'] === null ? null : (new Date(json['rangeUntil'])),
        'events': json['events'] == null ? undefined : json['events'],
        'sessions': json['sessions'] == null ? undefined : json['sessions'],
        'purchases': json['purchases'] == null ? undefined : json['purchases'],
        'transactions': json['transactions'] == null ? undefined : json['transactions'],
        'purchaseRevenue': json['purchaseRevenue'] == null ? undefined : json['purchaseRevenue'],
        'purchaseRevenueMissingCount': json['purchaseRevenueMissingCount'] == null ? undefined : json['purchaseRevenueMissingCount'],
        'canonicalPurchaseRevenue': json['canonicalPurchaseRevenue'] === undefined ? undefined : json['canonicalPurchaseRevenue'] === null ? null : json['canonicalPurchaseRevenue'],
        'purchaseRevenueCurrency': json['purchaseRevenueCurrency'] === undefined ? undefined : json['purchaseRevenueCurrency'] === null ? null : json['purchaseRevenueCurrency'],
        'purchaseRevenueAvailability': json['purchaseRevenueAvailability'] == null ? undefined : json['purchaseRevenueAvailability'],
        'purchaseRevenueByCurrency': json['purchaseRevenueByCurrency'] == null ? undefined : ((json['purchaseRevenueByCurrency'] as Array<any>).map(GoogleBigQueryGa4RevenueCurrencyDataFromJSON)),
        'landingPages': json['landingPages'] == null ? undefined : ((json['landingPages'] as Array<any>).map(GoogleBigQueryGa4ReportRowDataFromJSON)),
        'sources': json['sources'] == null ? undefined : ((json['sources'] as Array<any>).map(GoogleBigQueryGa4ReportRowDataFromJSON)),
        'paths': json['paths'] == null ? undefined : ((json['paths'] as Array<any>).map(GoogleBigQueryGa4ReportRowDataFromJSON)),
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GoogleBigQueryGa4ReportRowDataFromJSON)),
        'daily': json['daily'] == null ? undefined : ((json['daily'] as Array<any>).map(GoogleBigQueryGa4DailyReportRowDataFromJSON)),
    };
}

export function GoogleBigQueryGa4ReportDataToJSON(json: any): GoogleBigQueryGa4ReportData {
    return GoogleBigQueryGa4ReportDataToJSONTyped(json, false);
}

export function GoogleBigQueryGa4ReportDataToJSONTyped(value?: GoogleBigQueryGa4ReportData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'available': value['available'],
        'completeness': value['completeness'],
        'fetchedAt': value['fetchedAt'],
        'publishedAt': value['publishedAt'],
        'rangeSince': value['rangeSince'] == null ? value['rangeSince'] : value['rangeSince'].toISOString().substring(0,10),
        'rangeUntil': value['rangeUntil'] == null ? value['rangeUntil'] : value['rangeUntil'].toISOString().substring(0,10),
        'events': value['events'],
        'sessions': value['sessions'],
        'purchases': value['purchases'],
        'transactions': value['transactions'],
        'purchaseRevenue': value['purchaseRevenue'],
        'purchaseRevenueMissingCount': value['purchaseRevenueMissingCount'],
        'canonicalPurchaseRevenue': value['canonicalPurchaseRevenue'],
        'purchaseRevenueCurrency': value['purchaseRevenueCurrency'],
        'purchaseRevenueAvailability': value['purchaseRevenueAvailability'],
        'purchaseRevenueByCurrency': value['purchaseRevenueByCurrency'] == null ? undefined : ((value['purchaseRevenueByCurrency'] as Array<any>).map(GoogleBigQueryGa4RevenueCurrencyDataToJSON)),
        'landingPages': value['landingPages'] == null ? undefined : ((value['landingPages'] as Array<any>).map(GoogleBigQueryGa4ReportRowDataToJSON)),
        'sources': value['sources'] == null ? undefined : ((value['sources'] as Array<any>).map(GoogleBigQueryGa4ReportRowDataToJSON)),
        'paths': value['paths'] == null ? undefined : ((value['paths'] as Array<any>).map(GoogleBigQueryGa4ReportRowDataToJSON)),
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GoogleBigQueryGa4ReportRowDataToJSON)),
        'daily': value['daily'] == null ? undefined : ((value['daily'] as Array<any>).map(GoogleBigQueryGa4DailyReportRowDataToJSON)),
    };
}

